import { motion } from 'framer-motion'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const ParallaxOverflow = styled.div`
  width: 100%;
  @media (max-width: 1024px) {
    overflow-x: hidden;
    overflow-y: clip;
  }
`
export const ParallaxContainer = styled.div<{ $side: string }>`
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  max-width: calc(60rem + 2 * var(--spacing-sm));

  @media (max-width: 1024px) {
    position: relative;
    padding: 0 var(--spacing-sm);
  }
  img {
    position: absolute;
    right: ${(props) =>
      props.$side === 'left' ? 'calc(100% + 8vw - 30px);' : 'auto'};
    left: ${(props) =>
      props.$side === 'right' ? 'calc(100% + 8vw - 30px);' : 'auto'};
    //right: 100%;
    @media (max-width: 1280px) {
      right: ${(props) => (props.$side === 'left' ? '100%;' : 'auto')};
      left: ${(props) => (props.$side === 'right' ? '100%;' : 'auto')};
    }
    @media (max-width: 1024px) {
      position: relative;
      right: ${(props) => (props.$side === 'left' ? '0;' : 'auto')};
      left: ${(props) => (props.$side === 'right' ? '0;' : 'auto')};
      //right: 0;
    }
  }
`

export const ImageContainer = styled(motion.div)`
  position: relative;
  width: 100%;
  margin-bottom: var(--spacing-sm);

  ${mq.parallaxOff} {
    transform: none !important;
  }

  ${mq.parallaxOn} {
    width: calc((100vw - 100%) / 2);
    left: 100%;
    height: 0;
    margin-bottom: 0;
  }
`

export const Img = styled.img`
  display: block;
  max-width: 100%;
`
